import React from "react";

import { Flag, InfiniteScroll } from "@common/infiniteScroll";
import { Resource } from "../resource";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesList({
  resources,
  columns,
  isRequestPending,
  canLoadMore,
  retrieveNextResources,
}: Props) {
  return (
    <InfiniteScroll id="planzoneMembers">
      {() => (
        <div className={styles.scrolledList}>
          <ul className={styles.resourcesList}>
            {resources.map((resource) => (
              <li key={resource.uuid} className={styles.item}>
                <Resource resource={resource} columns={columns} />
              </li>
            ))}
          </ul>
          <Flag
            name="planzoneMembersFlag"
            retrieveItems={() => !isRequestPending && retrieveNextResources()}
            isDisabled={isRequestPending || !canLoadMore}
          />
        </div>
      )}
    </InfiniteScroll>
  );
}

export { ResourcesList };
